import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconHeart } from '../Icons';
import { getDecodedId } from '../../Utils/ProductUtils';

import { StyledBtn } from './SwymWishlistBtnPdpStyles';

var _ref = React.createElement(IconHeart, null);

var _ref2 = React.createElement(IconHeart, null);

var SwymWishlistBtnPdp = function SwymWishlistBtnPdp(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      productAddedToWishlist = _useState2[0],
      setProductAddedToWishlist = _useState2[1];

  var decodedVariantId = parseInt(getDecodedId(props.selectedVariant.id));
  var decodedProductId = parseInt(getDecodedId(props.product.id));

  var addToSwymWishlist = function addToSwymWishlist(e) {
    e.preventDefault();
    window._swat.addToWishList({
      epi: decodedVariantId,
      empi: decodedProductId,
      type: window._swat.ProductLevels.ProductVariant
    }, function () {
      setProductAddedToWishlist(true);
      // eslint-disable-next-line no-console
      console.log('Added to wishlist');
    });
  };

  var openModal = function openModal(e) {
    e.preventDefault();
    props.toggleAccountModal({ active: true, formType: 'WISHLIST' });
  };

  useEffect(function () {
    window._swat.initSwymWidgets(decodedVariantId);
  }, [decodedVariantId]);

  return window.Dormify.customerLoggedIn ? React.createElement(
    StyledBtn,
    {
      className: 'SwymWishlistBtn',
      onClick: function onClick(e) {
        return addToSwymWishlist(e);
      },
      productPage: props.productPage,
      isWishlistProduct: props.isWishlistProduct || productAddedToWishlist,
      'aria-label': 'Add to Wishlist'
    },
    _ref
  ) : React.createElement(
    StyledBtn,
    {
      className: 'SwymWishlistBtn',
      onClick: function onClick(e) {
        return openModal(e);
      },
      productPage: props.productPage,
      'aria-label': 'Add to Wishlist'
    },
    _ref2
  );
};

SwymWishlistBtnPdp.propTypes = {
  product: PropTypes.object.isRequired,
  productPage: PropTypes.bool,
  isWishlistProduct: PropTypes.bool,
  selectedVariant: PropTypes.object,
  toggleAccountModal: PropTypes.func.isRequired
};

export default SwymWishlistBtnPdp;